module.exports = __webpack_public_path__ + "img/designerHero.f1bdc6ee.svg";